// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 900) return "static/chunks/900-3d3c09f0f577f4b9.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"1ec7fe53eab3cec4","205":"4cc40c0e1f4cb0f2","319":"0cbc2894a3f1b950","340":"87975a191416dc74","367":"834b31d73689981f","639":"e7b660adfa99260e","748":"cfcac6772507111f"}[chunkId] + ".js";
};